import { getQueryStringFromObject as o, getQueryObjectFromObject as c } from "@partoohub/utils";
import { ApiResourceBaseClass as u } from "./baseApiCalls.js";
const a = "posts";
class _ extends u {
  /**
   * Gets a list of posts
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/posts`
   *
   * @param {Partial<PostFilterParams>} filterParams
   */
  getPostList = async (s) => {
    const { data: t } = await this.get(
      `${a}?${o(s)}`
    );
    return t;
  };
  /**
   * Gets a list of posts, grouped by bulk_id
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/posts/bulks`
   *
   * @param {Partial<PostFilterParams>} filterParams
   */
  getPostBulks = async (s) => {
    const { data: t } = await this.get(
      `${a}/bulks?${o(s)}`
    );
    return t;
  };
  /**
   * Creates posts
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/posts`
   *
   * @param {BusinessModalFilters} businessFilters
   * @param {CreatePostBody} payload
   * @param {Array<PostPublisherName>} platform
   */
  createPost = async (s, t, e) => {
    const i = c(s);
    i.partoo_ui = !0;
    const n = {
      business_search: i,
      data: t,
      publishers: e
    };
    t.expiration_time && (n.is_draft = !!t.expiration_time, n.send_notifications = !!t.send_notifications);
    const { data: r } = await this.post(`${a}`, n);
    return r;
  };
  /**
   * Updates a single post
   *
   * HTTP Verb: `PUT`
   * Endpoint URL: `/posts/:id`
   *
   * @param {number} postId
   * @param {UpdatePostBody} payload
   */
  updatePost = async (s, t) => {
    const { data: e } = await this.put(`${a}/${s}`, t);
    return e;
  };
  /**
   * Updates all posts in a given bulk
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/posts/edit_bulk`
   *
   * @param {number} bulkId
   * @param {UpdatePostBody} payload
   */
  updatePostBulk = async (s, t) => {
    const { data: e } = await this.post(`${a}/edit_bulk`, {
      bulk_id: s,
      post_data: t
    });
    return e;
  };
  /**
   * Deletes a single post
   *
   * HTTP Verb: `DELETE`
   * Endpoint URL: `/posts/:id`
   *
   * @param {number} postId
   */
  deletePost = async (s) => {
    const { data: t } = await this.delete(`${a}/${s}`);
    return t;
  };
  /**
   * Deletes all posts in a given bulk
   *
   * HTTP Verb: `POST`
   * Endpoint URL: `/posts/delete_bulk`
   *
   * @param {number} bulkId
   */
  deletePostBulk = async (s) => {
    const { data: t } = await this.post(`${a}/delete_bulk`, {
      bulk_id: s
    });
    return t;
  };
  /**
   * Counts the number of posts in a given bulk
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/posts/count_bulk/:id`
   *
   * @param {number} bulkId
   */
  countPostBulk = async (s) => {
    const { data: t } = await this.get(
      `${a}/count_bulk/${s}`
    );
    return t.count;
  };
  /**
   * Gets the state of a single post
   *
   * HTTP Verb: `GET`
   * Endpoint URL: `/posts/:id/state`
   *
   * @param {number} postId
   */
  getPostState = async (s) => {
    const { data: t } = await this.get(`${a}/${s}/state`);
    return t;
  };
}
export {
  _ as Post,
  _ as default
};
